import { createSelector } from '@reduxjs/toolkit';
import { selectBusinessNotificationSettings } from './notification-settings.selectors';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';

export const selectSelectedProjectNotificationSettings = createSelector(
  [selectBusinessNotificationSettings, selectSelectedProject],
  (businessNotificationSettings, selectedProject) => {
    if (selectedProject.businessTypeEnum === 'EMPLOYER') {
      return businessNotificationSettings[
        `BUSINESS_ID#${selectedProject.business_id}`
      ];
    } else {
      return {};
    }
  }
);
